import { TicketShortResponse, TicketResponse } from '@api/admin/adminGeneratedApi';

export const getHumanName = (data: TicketShortResponse | TicketResponse) => {
  if (data.human) return `${data.human.lastName || ''} ${data.human.firstName || ''} ${data.human.middleName || ''}`;
  if (data.humanName) return data.humanName;
  return null;
};
